import {
  AllowedLocale,
  LocaleActionTypes,
  LocaleAction
} from '../localeActionTypes';

export type i18nState = {
  locale: AllowedLocale,
}

const defaultState: i18nState = {
  locale: process.env.REACT_APP_DEFAULT_LOCALE as 'en',
};

const reducer = (
  state: i18nState = defaultState,
  action: LocaleAction
): i18nState => {
  switch (action.type) {
    case LocaleActionTypes.SET_LOCALE:
      return {...state, locale: action.payload};

    default:
      return state;
  }
};

export default reducer;
